import { useGetApplicazioniAnagraficaApplicazione } from '@framework/api-client';
import { useDispatch } from 'react-redux';
import { useAuth } from '../state/AuthSlice';
import { ClientConfigActions } from './ClientConfigSlice';

export interface IClientConfigLoaderProps {}

/**
 * Carica la configurazione del client e la salva nello store.
 */
export function ClientConfigLoader(props: IClientConfigLoaderProps) {
  const dispatch = useDispatch();
  const { isLogged } = useAuth();
  const { data } = useGetApplicazioniAnagraficaApplicazione({
    query: {
      enabled: isLogged,
      keepPreviousData: true,
      onSuccess: clientConfig => {
        dispatch(ClientConfigActions.setClientConfig(clientConfig));
      },
    },
  });

  return null;
}
